import React, { useState } from 'react';

import Input from '@components/uikit/Input/Input';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { useUpdateOrDeleteWorkOrderMutation } from '@pages/ActionItem/services/useUpdateOrDeleteWorkOrderMutation';

import style from './style.module.scss';

interface IProps {
  woNumber: string;
  actionItemId: number;
  permissionChangeWO: boolean;
}

const EditField: React.FC<IProps> = ({ woNumber = '', actionItemId, permissionChangeWO }) => {
  const { t } = useTranslation();

  const [isEdit, setIsEdit] = useState(false);
  const [woNumberValue, setWoNumberValue] = useState(woNumber);

  const { mutate: updateOrDeleteWorkOrderMutate, isLoading } = useUpdateOrDeleteWorkOrderMutation({
    actionItemId,
  });

  const saveWoNumber = () => {
    if (woNumber !== woNumberValue) {
      updateOrDeleteWorkOrderMutate(
        { wo_number: woNumberValue, action_item_id: +actionItemId },
        {
          onSuccess: () => {
            showToast({
              variant: 'success',
              message: t(
                woNumberValue ? 'The work order has been added.' : 'The work order has been deleted.',
              ),
            });

            setIsEdit(false);
          },
        },
      );
    } else {
      setIsEdit(false);
    }
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isLoading) {
      if (e.key === 'Enter') {
        saveWoNumber();
      }

      if (e.key === 'Escape') {
        setIsEdit(false);
        setWoNumberValue(woNumber);
      }
    }
  };

  if (!permissionChangeWO) {
    return (
      <div>
        <label className={style.label}>{t('Work Order')}</label>
        <div className={style.infoField}>
          <div className={style.infoFieldValue}>{woNumberValue}</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <label className={style.label}>{t('Work Order')}</label>
      {!isEdit && (
        <div className={style.infoField}>
          {woNumberValue ? (
            <>
              <div className={style.infoFieldValue}>{woNumberValue}</div>
              <button className={style.editFieldBtn} onClick={() => setIsEdit(true)}>
                {t('Edit')}
              </button>
            </>
          ) : (
            <button className={style.editFieldBtn} onClick={() => setIsEdit(true)}>
              {`+ ${t('Add work order')}`}
            </button>
          )}
        </div>
      )}
      {isEdit && (
        <Input
          value={woNumberValue}
          autoFocus={true}
          rightElement={
            <button className={style.editFieldBtn} disabled={isLoading} onClick={saveWoNumber}>
              {t('Save')}
            </button>
          }
          disabled={isLoading}
          onKeyDown={handleInputKeyDown}
          onChange={({ target }) => setWoNumberValue(target.value)}
          dataQa={'wo_number'}
          type={'woHelperText'}
        />
      )}
    </div>
  );
};

export default EditField;
